import { useEffect, useRef, useState } from "react";
import { io, Socket } from "socket.io-client";
import { clearStoredPassword, getStoredPassword } from "./auth";
import { Role, StateSyncPayload } from "./types";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "http://localhost:3000";

export function useGameSocket(role: Role) {
  const [state, setState] = useState<StateSyncPayload | null>(null);
  const socketRef = useRef<Socket | null>(null);

  useEffect(() => {
    const socket = io(BACKEND_URL, { auth: { password: getStoredPassword() } });
    socketRef.current = socket;

    socket.on("connect", () => {
      socket.emit("join", { role });
    });

    socket.on("state:sync", (payload: StateSyncPayload) => {
      setState(payload);
    });

    socket.on("connect_error", (err) => {
      if (err.message === "unauthorized") {
        clearStoredPassword();
        window.location.reload();
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [role]);

  return { state, socket: socketRef.current };
}
